import { render, staticRenderFns } from "./ManagementView.vue?vue&type=template&id=49d3320c&"
import script from "./ManagementView.vue?vue&type=script&lang=ts&"
export * from "./ManagementView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports